<div class="wd-100 ht-100 flex-col-container">
        <div class="flex-row-center m-t25 prop-container__header B">
            Delete Plan
        </div>
        <div class="flex-col-center">
            <span class="font18 m-t25 m-lr-25">Do you want to delete this plan?</span>                   
            <span class="blueText18 m-15">{{planName}}</span>   
        </div>
        <div class="flex-row-end m-t25 m-tb5 p-r25" >
            <span *ngIf="!isDataAvailable" class="error m-25">{{errorMsg}}</span> 
            <button mat-raised-button color="basic" (click)="closeDialog()" class="m-l10">Cancel</button>
            <button mat-raised-button color="primary" (click)="deletePlan()" class="m-l10">Delete</button>                    
        </div>    
</div>